import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, pipe } from 'rxjs';
import { first } from 'rxjs/operators';

import { AuthService } from '../services';
import { LogInInterface } from '../interfaces';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  model: LogInInterface = {
    email: '',
    password: ''
  };
  loading = false;
  returnUrl: string;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    // reset login status
    this.authService.logout();

    // get return url from route parameters or default to '/'
    // tslint:disable-next-line:no-string-literal
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login() {
    this.loading = true;
    this.error = '';
    this.authService.login(this.model).pipe(
      first()
    ).subscribe(
      data => {
        this.router.navigate([this.returnUrl]);
      },
      error => {
        this.error = error.error.message;
        if (!this.error) {
          this.error = 'wrong username or password';
        }
        this.loading = false;
      });
  }

  loginClick() {
    // this.router.navigateByUrl('/');
    this.login();
  }

}
